import React, { useState, useEffect, useRef } from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'

import { Button, IconButton, Typography, Icon, Switch, Tooltip } from '@material-ui/core'

import { CalendarToday, ArrowBackIosOutlined, ArrowForwardIosOutlined, Menu, SubdirectoryArrowRight, LockOpen, Loop, Lock, ArrowForwardIos, Check, Close } from '@material-ui/icons'

import { KeyboardDatePicker } from '@material-ui/pickers'

import moment from 'moment'
import clsx from 'clsx'
import { useLocation } from 'react-router-dom'

import ScrollContainer from 'react-indiana-drag-scroll'
import { useSelector, useDispatch } from 'react-redux'
import LoadingOverlay from '../../components/Misc/LoadingOverlay'
import ErrorBoundary from '../../components/Misc/ErrorBoundary'
import { v4 as uuid } from 'uuid'
import {
	postDisabledWindow,
	removeAllDisabledWindow,
	removeDisabledWindow
} from '../../actions/disabledWindows/disabledWindows.actions'
import Loading from '../../components/Misc/Loading'
import { isHoliday } from '../../services/helpers'
import {
	getAggregatedVisits,
	updateFacility,
	setAutoCap,
	removeAutoCap,
	recalculateCap
} from '../../actions/facilities/facilities.actions'
import ModeDialog from '../../components/Dialogs/ModeDialog'
import CapStatusDialog from '../../components/Dialogs/CapStatusDialog'
import { cloneDeep } from 'lodash'
import { create, remove } from '../../actions/facilityVacationDays/facilityVacationDays.actions'

const NewToolTip = withStyles({
	tooltip: {
		backgroundColor: "#FFFFFF",
		boxShadow: '0px 2px 15px rgba(26, 26, 53, 0.2)'
	}
})(Tooltip);

const useStyles = makeStyles((theme) => ({
	root: {
		flex: 1,
		paddingBottom: 60,
		"& .MuiTooltip-tooltip": {
			backgroundColor: '#FFFFFF'
		}
	},
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#F9F9F9',
		position: 'relative'
	},
	toolbarExtras: {
		display: 'flex',
		'& > *': {
			marginRight: '16px'
		},

	},
	recalculateButton: {
		position: 'absolute',
		right: 24,
		backgroundColor: '#6B4AD6',
		color: '#FFFFFF'
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		padding: '24px 25px',
		'& > div:nth-child(1)': {
			'& > div:nth-child(4)': {
				flex: 'auto'
			}
		}
	},
	datePickerContainer: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative'
	},
	datePicker: {
		color: '#FFFFFF',
		opacity: 0,
		position: 'absolute',
		top: 0,
		height: 38,
		margin: 0,
		'& *': {
			height: 0,
			padding: 0,
			margin: 0
		}
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	calendarDateButton: {
		zIndex: 1,
		border: '1px solid #D0CFD2',
		padding: '7px 16px 8px 24px',
		color: '#4D4C4F',
		fontWeight: '700',
		'& .MuiButton-label': {
			'& .MuiButton-endIcon': {
				marginLeft: 16
			},
			whiteSpace: 'nowrap'
		}
	},
	dateChangeButton: {
		border: '1px solid #D0CFD2',
		height: 38,
		width: 38,
		padding: 5,
		'& svg': {
			height: 16
		}
	},
	timeBlocksSection: {
		// marginTop: 8,
		// paddingLeft: 16,
		// paddingRight: 16
	},
	scrollWrapper: {
		display: 'flex',
		background: '#FFFFFF',
		paddingLeft: 16,
		paddingRight: 16
	},
	capScrollWrapper: {
		display: 'flex',
		borderTop: '1px solid #D0CFD2',
		borderBottom: '1px solid #D0CFD2'
	},
	compatibilityScrollWrapper: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start'
	},
	dates: {
		display: 'flex',
		width: '100%'
	},
	rowHeads: {
		position: 'absolute',
		left: 0,
		background: '#FFFFFF'
	},
	rowHead: {
		display: 'flex',
		height: '100%',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		height: 56,
		paddingLeft: 20,
		paddingRight: 20,
		borderRight: '1px solid #F3F3F3',
		minWidth: 160
	},
	capRowHead: {
		display: 'flex',
		height: '100%',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		height: 38,
		paddingLeft: 20,
		paddingRight: 20,
		borderRight: '1px solid #D0CFD2',
		minWidth: 160
	},
	row: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	smallRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	capRow: {
		display: 'flex',
		minWidth: 149,
		height: '100%',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		height: 38,
		paddingLeft: 16,
		borderRight: '1px solid #D0CFD2',

		'&:last-child': {
			borderRight: 'none'
		},
		'& .fas::before': {
			fontWeight: '900',
			fontSize: '16px',
			lineHeight: '16px',
			letterSpacing: '1.8px'
		},
		'& .fa-check-circle::before': {
			color: '#6B4AD6'
		},
		'& .fa-times-circle::before': {
			color: '#D0CFD2'
		}
	},
	day: {
		display: 'flex',
		width: '20%',
		minWidth: 149,
		height: '100%',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		height: 56,
		borderRight: '1px solid #F3F3F3',
		'&:last-child': {
			borderRight: 'none'
		},
		'& .fas::before': {
			fontWeight: '900',
			fontSize: '16px',
			lineHeight: '16px',
			letterSpacing: '1.8px'
		},
		'& .fa-check-circle::before': {
			color: '#6B4AD6'
		},
		'& .fa-times-circle::before': {
			color: '#D0CFD2'
		}
	},
	active: {
		background: 'rgba(107, 74, 214, 0.1)'
	},
	disabled: {
		opacity: 0.5
	},
	number: {
		fontWeight: '600',
		fontSize: '16px',
		lineHeight: '22px',
		userSelect: 'none',
		textAlign: 'center'
	},
	word: {
		fontWeight: '800',
		fontSize: '12px',
		lineHeight: '16px',
		letterSpacing: 0.75,
		textTransform: 'uppercase',
		userSelect: 'none',
		textAlign: 'center'
	},
	openClose: {
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: '12px',
		lineHeight: '16px',
		letterSpacing: '0.75px',
		textTransform: 'uppercase',
		display: 'none',
		cursor: 'pointer',
		color: '#6B4AD6'
	},
	dateWrapper: {
		display: 'flex',
		width: '100%',
		height: '100%',
		padding: '0px 14px',
		justifyContent: 'space-between',
		alignItems: 'center',
		'&:hover': {
			'& .open-close': {
				display: 'initial'
			}
		}
	},
	count: {
		color: '#6B4AD6',
		fontSize: '16px',
		fontWeight: '800'
	},
	switchRoot: {
		width: 30,
		height: 20,
		padding: 0
	},
	switchBase: {
		padding: 0,
		margin: 2,
		'&$checked': {
			transform: 'translateX(10px)',
			color: theme.palette.common.white,
			'& .far::before': {
				color: '#6B4AD6'
			}
		},
		'&.MuiSwitch-switchBase.Mui-checked': {
			transform: 'translateX(10px)'
		},
		'&$checked + $track': {
			backgroundColor: '#6B4AD6',
			opacity: 1
		},
		'&$focusVisible $thumb': {
			color: '#6B4AD6',
			opacity: 1
		},
		'&.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
			backgroundColor: '#6B4AD6',
			opacity: 1
		},
		'&.MuiSwitch-switchBase.Mui-checked .far.fa-check::before': {
			color: '#6B4AD6'
		}
	},
	thumb: {
		width: 16,
		height: 16,
		background: '#F3F3F3',
		border: '1px solid #E5E5E5',
		borderRadius: '50%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& .far': {
			color: '#A2A1A4',
			fontSize: '13px'
			// lineHeight: "15px",
		}
	},
	track: {
		borderRadius: 100,
		padding: 2,
		backgroundColor: '#D0CFD2',
		opacity: 1,
		transition: theme.transitions.create(['background-color'])
	},
	blockInt: {
		width: '100%',
		backgroundColor: '#FFFFFF',
		borderRadius: 8,
		padding: 8
	},
	block: {
		width: '20%',
		paddingRight: 8
	},
	blockTitle: {
		fontSize: 14,
		fontWeight: '800',
		marginBottom: 12,
		marginTop: 16,
		textTransform: 'uppercase'
	},
	blockColumn: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		width: '100%'
	},
	blockType: {
		borderRadius: 4,
		border: '1px solid #D0CFD2',
		width: '100%',
		padding: 8,
		marginBottom: 8
	},
	tooltip: {
		backgroundColor: '#FFFFFF',
		padding: 12,
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'flex-start'
	},
	header: {
		color: '#1A1A35',
		fontSize: 14,
		fontWeight: '800',
		letterSpacing: .75,
		fontFamily: 'Nunito',
		textTransform: 'uppercase'
	},
	headerBox: {
		// border: '1px solid #D0CFD2',
		borderLeftWidth: 0,
		borderRightWidth: 0,
		padding: 12
	},
	dateRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
	},
	dayInt: {
		display: 'flex',
		width: '20%',
		minWidth: 149,
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		height: 56,
		backgroundColor: '#FFFFFF',
		border: '1px solid #F3F3F3',
	},
	dayInt2: {
		display: 'flex',
		width: '20%',
		minWidth: 149,
		flexDirection: 'row',
		paddingLeft: 16,
		justifyContent: 'flex-start',
		alignItems: 'center',
		height: 56,
		backgroundColor: '#FFFFFF',
		border: '1px solid #F3F3F3',
	},
	dayText: {
		color: '#1A1A35',
		fontSize: 14,
		fontWeight: '600',
		fontFamily: 'Nunito'
	}
}))

function useQuery() {
	return new URLSearchParams(useLocation().search)
}

const ServicesAvailability = () => {
	const classes = useStyles()
	const query = useQuery()
	const dispatch = useDispatch()
	const container = useRef(null)
	const facility = useSelector((state) => state.specific.facilities.selected)
	const loading = useSelector((state) => state.specific.facilities.loading)
	const service_page_loading = useSelector((state) => state.specific.facilities.service_page_loading)
	const counts = useSelector((state) => state.specific.facilities.capacity)
	const [openDay, setOpenDay] = useState({})
	const [dates, setDates] = useState([])
	const [mode, showMode] = useState({})
	const [openLocked, showOpenLocked] = useState({})
	const [date, setDate] = useState(
		query.get('date') ? moment(query.get('date')).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
	)
	const [isOpen, setIsOpen] = useState(false)
	const [setup, setSetup] = useState(null)
	const [windows, setWindows] = useState(null)
	const [openConfirmModal, setOpenConfirmModal] = useState(false)

	let timeblocks = ['morning', 'afternoon', 'evening']

	useEffect(() => {
		if (date && facility) {

			const start = moment(date).startOf('week')
			const end = moment(date).endOf('week')

			dispatch(getAggregatedVisits(facility._id, date))
			const date_range = []

			for (let i = start; i.isBefore(moment(end).endOf('day')); i.add(1, 'day')) {
				date_range.push(i.clone())
			}

			setDates(date_range)
		}
	}, [date, facility])


	useEffect(() => {
		if (dates && dates.length && facility) {
			setSetup(
				dates
					.map((d) => {
						let found = facility.compatibility_day_setup.find(
							(w) => w.day === moment(d).startOf('D').day()
						)

						if (found) {
							return {
								...found,
								date: d,
								loading: false,
								windows: found.windows.map((w) => ({ ...w, loading: false }))
							}
						}
					})
					.filter(Boolean)
			)
		}
	}, [dates])

	useEffect(() => {
		if (setup) {
			setWindows(
				timeblocks.map((timeblock) => {
					return setup.map((s) => {
						let foundWindowIndex = (s.windows || []).findIndex((w) => w.name === timeblock)

						return {
							...s,
							window: s.windows[foundWindowIndex]
						}
					})
				})
			)
		}
	}, [setup])

	const setCapacity = async (newMode) => {
		dispatch({ type: 'SERVICE_PAGE_LOADING' })
		showMode({})
		const ourDate = newMode.date
		const type = newMode.block_type
		const capacity = newMode.capacity
		dispatch(setAutoCap(ourDate, facility._id, type, capacity))
		await sleep()
		dispatch(getAggregatedVisits(facility._id, date))
		setOpenDay({})
	}

	const sleep = () => {
		return new Promise((res, rej) => {
			setTimeout(() => {
				res()
			}, 2000)
		})
	}

	const setOpenLocked = (newMode) => {
		dispatch({ type: 'SERVICE_PAGE_LOADING' })
		showOpenLocked({})
		const ourDate = newMode.date
		let type = newMode.block_type

		if (type === 'total_daytime') type = 'daytime'

		// see if there is a holiday we should remove...
		if (newMode.status === 'Open') {
			let exists = counts?.[ourDate]?.holidays.find(ac => ac.type === type)
			if (exists) {
				dispatch(remove(exists))
			} else {
				dispatch({ type: 'SERVICE_PAGE_NOT_LOADING' })
			}
		} else {
			const newHoliday = {
				startDate: ourDate,
				endDate: ourDate,
				facility_id: facility._id,
				type,
				name: 'Manually Closed'
			}
			dispatch(create(newHoliday))
		}
	}

	const changeDate = (type) => {
		if (type === 'add') {
			setDate(moment(date).add(5, 'days').format('YYYY-MM-DD'))
		} else if (type === 'subtract') {
			setDate(moment(date).subtract(5, 'days').format('YYYY-MM-DD'))
		}
	}

	const updateDate = (date) => {
		setDate(moment(date).format('YYYY-MM-DD'))
		setIsOpen(false)
	}

	const getDateElements = () => {
		return dates.map((d) => {
			let isCurrentDay = false
			let disabled = moment(d).startOf('D').isBefore(moment().startOf('D'))

			let now = moment()
			let beginningOfDay = moment(d)

			if (now.isSame(beginningOfDay, 'day')) isCurrentDay = true

			return (
				<div
					key={d.format()}
					className={clsx(classes.day, isCurrentDay && classes.active)}>
					<Typography className={classes.number}>{d.format('D')}</Typography>
					<Typography className={classes.word}>{d.format('ddd')}</Typography>
				</div>
			)
		})
	}


	const disableDay = (timeblock, window) => {
		let updates
		let foundIndex
		let timeBlockIndex

		if (timeblock) {
			updates = cloneDeep(windows)
			timeBlockIndex = timeblocks.findIndex((t) => t === timeblock)
			foundIndex = updates[timeBlockIndex].findIndex((w) => moment(w.date).isSame(moment(window.date)))

			if (foundIndex !== -1) {
				updates[timeBlockIndex][foundIndex].window.loading = true

				setWindows([...updates])
			}
		} else {
			updates = cloneDeep(setup)
			foundIndex = updates.findIndex((s) => moment(s.date).isSame(moment(window.date)))

			if (foundIndex !== -1) {
				updates[foundIndex].loading = true

				setSetup([...updates])
			}
		}

		dispatch(
			postDisabledWindow({
				...window,
				date_string: window.date.format('YYYY-MM-DD')
			})
		)
	}

	const enableFullDay = (windows) => {
		if (windows && windows.length) {
			let updates = cloneDeep(setup)
			let foundIndex = updates.findIndex((s) => moment(s.date).isSame(moment(window.date)))

			if (foundIndex !== -1) {
				updates[foundIndex].loading = true

				setSetup([...updates])
			}

			dispatch(
				removeAllDisabledWindow({
					date: windows[0].date,
					facility_id: windows[0].facility_id
				})
			)
		}
	}

	const enableDay = (window) => {
		let updates
		let foundIndex

		updates = cloneDeep(setup)
		foundIndex = updates.findIndex((s) => moment(s.date).isSame(moment(window.date)))

		if (foundIndex !== -1) {
			updates[foundIndex].loading = true

			setSetup([...updates])
		}

		dispatch(removeDisabledWindow(window))
	}

	const disableVisitDay = (holiday) => {
		let updates
		let foundIndex

		updates = cloneDeep(setup)
		foundIndex = updates.findIndex((s) => moment(s.date).isSame(moment(holiday.startDate)))

		if (foundIndex !== -1) {
			updates[foundIndex].loading = true

			setSetup([...updates])
		}

		dispatch(create(holiday))
	}

	const enableVisitDay = (holiday) => {
		let updates
		let foundIndex

		updates = cloneDeep(setup)
		foundIndex = updates.findIndex((s) => moment(s.date).isSame(moment(holiday.startDate)))

		if (foundIndex !== -1) {
			updates[foundIndex].loading = true

			setSetup([...updates])
		}

		dispatch(remove(holiday))
	}


	const recalculate = () => {
		const formattedDate = moment(date, 'll').format('MM-DD-YYYY')

		let sundayStart = moment(date).day(0).format()

		dispatch(recalculateCap(formattedDate, facility._id, sundayStart))
	}

	const getIcon = (block_type) => {
		if (block_type === 'total' || block_type === 'overflow' || block_type === 'compat_total') return <Menu fontSize="small" style={{ fontSize: 14, marginRight: 8, marginLeft: 4, fill: '#270050' }} />
		return <SubdirectoryArrowRight fontSize="small" style={{ fontSize: 14, marginRight: 8, marginLeft: 4, fill: '#270050' }} />

	}

	const getDogs = (block_type, ourDate) => {

		if (block_type === 'overflow') {
			let daytime = facility?.capacity?.daytime || 150
			let daytime_count = counts?.[ourDate]?.['daytime'] || 0
			let diff = daytime - daytime_count
			if (diff < 0) return Math.abs(diff)
		}

		return counts?.[ourDate]?.[block_type] || 0

	}

	const getCapacity = (block_type, ourDate) => {
		let capacity = facility?.capacity?.total || 150
		if (block_type === 'daycare') {
			const { daycare_days } = facility.capacity
			const day_of_week = moment(ourDate, 'YYYY-MM-DD').format('dddd')
			const weekday_cap = daycare_days[day_of_week]
			if (weekday_cap) {
				capacity = weekday_cap
			} else {
				capacity = facility?.capacity?.daycare_only || 150
			}
		}

		let dayOfWeek = moment(ourDate).format('dddd')

		if (block_type === 'total_daytime') capacity = facility?.capacity?.daytime || 150
		if (block_type === 'overnight') capacity = facility?.capacity?.overnight || 150
		if (block_type === 'daycare_with_boarding') capacity = null
		if (block_type === 'overflow') capacity = null
		if (block_type === 'welcome') capacity = facility?.capacity?.welcome_day || 10

		let originalCapacity = capacity
		let updatedCapacity = null

		if (['daycare', 'welcome', 'overnight'].includes(block_type)) {
			let hasManualCapacity = counts[ourDate]?.autoCaps?.find(ac => !!ac.hasOwnProperty('capacity') && ac.type === block_type)
			if (hasManualCapacity) updatedCapacity = hasManualCapacity.capacity
		}

		return { originalCapacity, updatedCapacity }
	}


	const isParentCapLocked = (block_type, ourDate, compat) => {

		if (block_type === 'total' || block_type === 'compat_total') return false


		let total_cap = counts?.[ourDate]?.holidays?.find(ac => ac.type === 'total')
		if (total_cap) return true

		if (block_type === 'daycare' || block_type === 'daycare_with_boarding' || block_type === 'welcome') {
			let cap = counts?.[ourDate]?.holidays?.find(ac => ac.type === 'daytime')
			if (cap) return true
		}

		return false

	}

	const renderIcon = (manual, locked) => {
		let style = {
			fontSize: 14,
			fontWeight: '800'
		}
		if (manual) {
			return null
			// style.fill = '#FFFFFF'
			// return <LockOpen style={style} />
		}
		if (locked) {
			style.fill = '#4D4C4F'
			return <Lock style={style} />
		}

		style.fill = '#6B4AD6'
		return <Loop style={style} />
	}



	const getBlockStatus = (block_type, ourDate) => {

		if (block_type === 'overflow') return {}

		let manual = counts?.[ourDate]?.autoCaps?.find(ac => ac.type === block_type && ac.manual_control)
		let locked = isParentCapLocked(block_type, ourDate)

		let cap;

		if (block_type === 'overnight') {
			cap = counts?.[ourDate]?.holidays?.find(ac => ac.type === 'overnight')
		} else if (block_type === 'daycare_with_boarding') {
			cap = counts?.[ourDate]?.holidays?.find(ac => ac.type === 'daytime')
		} else if (block_type === 'daycare') {
			cap = counts?.[ourDate]?.holidays?.find(ac => ac.type === 'daytime' || ac.type === 'daycare')
		} else if (block_type === 'total_daytime') {
			cap = counts?.[ourDate]?.holidays?.find(ac => ac.type === 'daytime')
		} else if (block_type === 'welcome') {
			cap = counts?.[ourDate]?.holidays?.find(ac => ac.type === 'welcome' || ac.type === 'daycare' || ac.type === 'daytime')
		}


		let total_cap = counts?.[ourDate]?.holidays?.find(ac => ac.type === 'total')
		if (total_cap) cap = total_cap


		let status = 'Open'

		if (cap) {
			status = 'Closed'
		}

		if (locked) status = 'Closed'

		const isManual = manual ? true : false

		return { isManual, status }
	}



	const renderBlock = (block_type, ourDate) => {

		const date = ourDate.format('YYYY-MM-DD')

		let number = getDogs(block_type, date)
		let { originalCapacity, updatedCapacity } = getCapacity(block_type, date)

		let capacity = updatedCapacity || updatedCapacity === 0 ? updatedCapacity : originalCapacity

		let capString = `${number}`
		if (capacity || capacity === 0) capString += ` of ${capacity}`

		const { isManual, status } = getBlockStatus(block_type, date)

		const bad_types = ['total', 'overflow', 'total_daytime']

		let iconName = "fas fa-arrow-circle-up"

		let iconStyle = { fontSize: 16, overflow: 'visible', marginRight: 6 }

		let textStyle = {}

		let capChanged = !!(updatedCapacity || updatedCapacity === 0) && updatedCapacity !== originalCapacity

		if (status === 'Closed') {
			// iconStyle.color = '#DB4A42'
			textStyle.color = '#A2A1A4'
		}

		if (capChanged) {
			if (updatedCapacity < originalCapacity) {
				iconName = "fas fa-arrow-circle-down"
				iconStyle.color = '#DC2A2A'
			} else {
				iconStyle.color = '#007A4B'
			}
		}


		const showMenu = !bad_types.includes(block_type)

		return (
			<div key={`${block_type}-${date}`} className={classes.dayInt} style={{ position: 'relative' }}>
				<IconButton
					style={{ position: 'absolute', top: 0, right: 0, visibility: showMenu ? 'visible' : 'hidden' }}
					tabIndex={showMenu ? 0 : -1}
					aria-hidden={!showMenu}
					onClick={showMenu ? () => setOpenDay({ block_type, date, status }) : undefined}>
					<Icon className="fa fa-ellipsis-h" style={{ color: '#4D4C4F', fontSize: 14 }} />
				</IconButton>
				<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
					<Icon className={iconName} style={{ ...iconStyle, visibility: capChanged ? 'visible' : 'hidden', display: capChanged ? undefined : 'none' }} />
					<Typography className={classes.dayText} style={textStyle}>{capString}</Typography>
				</div>
			</div>
		)
	}

	const tooltipMap = {
		daycare: "Total capacity for daycare-only dogs (includes Welcome Day dogs). Takes place between 9am - 7pm.",
		welcome: "Total capacity for Welcome Day dogs.",
		total_daytime: 'Total capacity for daytime sessions (daycare-only, boarding with daycare, and welcome day) per day. Takes place between 7pm - 9am.',
		overnight: 'Total capacity for overnight kennels. Takes place between 7pm-9am.',
		overflow: 'Total number of dogs booked over capacity.',
		total: 'Total number of kennels in the facility. Some dogs are included in both daytime and overnight, so the total does not reflect the number of dogs we can care for at any one time. This does not include dogs in ISO, as those are used for emergencies.'
	}


	const getPetCareBlocks = () => {


		const block_types = [
			{
				section: 'Daytime',
				blocks: [
					{ name: 'Daycare', type: 'daycare' },
					{ name: 'Welcome Day', type: 'welcome' },
					{ name: 'Total Daytime', type: 'total_daytime' }
				]
			},
			{
				section: 'Overnight',
				blocks: [
					{ name: 'Total', type: 'overnight' }
				]
			},
			{
				section: 'Total',
				blocks: [{ name: 'Overflow', type: 'overflow' }, { name: 'Facility Total', type: 'total' }]
			}
		]

		return (
			<div style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'flex-start',
				width: '100%'
			}}>
				{
					block_types.map(type => {
						return (
							<div key={type.section}>
								<div className={classes.headerBox}>
									<Typography className={classes.header}>{type.section}</Typography>
								</div>
								<div>
									{type.blocks.map(b => {
										return (
											<div key={b.type} className={classes.dateRow}>
												<div className={classes.dayInt2}>
													<Tooltip title={tooltipMap[b.type]}>
														<Icon className="fas fa-info-circle" style={{ fontSize: 16, overflow: 'visible', color: '#3B0275', marginRight: 8 }} />
													</Tooltip>
													<Typography className={classes.dayText}>{b.name}</Typography>
												</div>
												{dates.map(d => renderBlock(b.type, d))}
											</div>
										)
									})}
								</div>
							</div>
						)
					})
				}
			</div>

		)


	}

	const getModeTitle = () => {
		if (!openDay?.block_type) return null

		console.log('open.', openDay)

		const titles = {
			'total': 'Facility Total',
			'total_daytime': 'Total Daytime',
			'daycare': 'Daycare',
			'welcome': 'Welcome Day',
			'daycare_with_boarding': 'Daycare w/Boarding',
			'overnight': 'Overnight',
			'overflow': 'Overflow'
		}

		let modeTitle = `${titles[openDay.block_type]} - ${moment(openDay.date).format('MMM D, YYYY')}`
		if (openConfirmModal) modeTitle = 'Change ' + modeTitle
		return modeTitle
	}

	const getOpenLockedTitle = () => {
		if (!openLocked?.block_type) return null

		const titles = {
			'total': 'Total',
			'daytime': 'Daytime',
			'daycare': 'Daycare',
			'daycare_with_boarding': 'Daycare w/Boarding',
			'overnight': 'Overnight',
			'overflow': 'Overflow'
		}

		return `${titles[openLocked.block_type]} Status - ${moment(openLocked.date).format('MMM D, YYYY')}`
	}

	return (
		<div className={classes.root}>
			{service_page_loading ? <LoadingOverlay /> : null}
			<div className={classes.toolbarWrapper}>
				<div className={classes.toolbar}>
					<Typography style={{ marginRight: 24 }} variant="h6" color="inherit">
						Services Availability
					</Typography>
					<div className={classes.toolbarExtras}>
						<div className={classes.datePickerContainer}>
							<Button
								className={clsx(classes.headerButton, classes.calendarDateButton)}
								onClick={() => setIsOpen(true)}
								variant="outlined"
								endIcon={<CalendarToday style={{ height: 19, width: 19, fill: '#777679' }} />}
								size="large">
								{date}
							</Button>
							<KeyboardDatePicker
								disableToolbar
								open={isOpen}
								onOpen={() => setIsOpen(true)}
								onClose={() => setIsOpen(false)}
								variant="inline"
								format="MM/DD/YYYY"
								margin="normal"
								id="start-date"
								label="Start Date"
								inputVariant="filled"
								value={date}
								onChange={updateDate}
								className={classes.datePicker}
								rightArrowIcon={
									<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
								}
								leftArrowIcon={<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />}
								KeyboardButtonProps={{
									'aria-label': 'Start Date',
									className: classes.calendarButton
								}}
							/>
						</div>
						<IconButton className={classes.dateChangeButton} onClick={() => changeDate('subtract')}>
							<ArrowBackIosOutlined style={{ fill: '#777679' }} />
						</IconButton>
						<IconButton className={classes.dateChangeButton} onClick={() => changeDate('add')}>
							<ArrowForwardIosOutlined style={{ fill: '#777679' }} />
						</IconButton>
					</div>
					{/*<Button
						className={classes.recalculateButton}
						onClick={() => recalculate()}
						variant="outlined"
						size="large">
						RECALCULATE
					</Button>*/}
				</div>
			</div>
			<div className={classes.scrollWrapper}>
				<ScrollContainer className={classes.dates} ref={container}>
					<div
						className={classes.day}>
					</div>
					{getDateElements()}
				</ScrollContainer>
			</div>

			<div className={classes.timeBlocksSection} style={{ minHeight: 168 }}>
				<div className={classes.compatibilityScrollWrapper}>
					{getPetCareBlocks()}
				</div>
			</div>
			<ModeDialog
				title={getModeTitle()}
				counts={counts}
				facility={facility}
				isShown={!!openDay?.block_type}
				currentDay={openDay}
				confirmSave={setCapacity}
				openConfirmModal={openConfirmModal}
				setOpenConfirmModal={setOpenConfirmModal}
				closeDay={setOpenLocked}
				setIsShown={() => setOpenDay({})} />
			<CapStatusDialog
				title={getOpenLockedTitle()}
				isShown={!!openLocked.block_type}
				currentMode={openLocked}
				confirmSave={setOpenLocked}
				setIsShown={() => showOpenLocked({})} />
		</div>
	)
}

const ServicesAvailabilityWithBoundary = (props) => (
	<ErrorBoundary>
		<ServicesAvailability {...props} />
	</ErrorBoundary>
)

export default ServicesAvailabilityWithBoundary